import { createRouter, createWebHashHistory } from 'vue-router';

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: () => import('@/layout/DefaultLayout.vue'),
      meta: { title: '星通投放后台' },
      children: [
        { path: 'home', component: () => import('@/views/HomePage.vue'), alias: '' },
        { path: 'book/bookList', component: () => import('@/views/book/BookList.vue'), meta: { keepAlive: true } },
        {
          path: 'book/chapterList',
          component: () => import('@/views/book/ChapterList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/postbackStrategyList',
          component: () => import('@/views/promotion/PostbackStrategyList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/promotionLinkList',
          component: () => import('@/views/promotion/PromotionLinkList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'operate/payTemplateList',
          component: () => import('@/views/operate/PayTemplateList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'operate/noticeList',
          component: () => import('@/views/operate/NoticeList.vue'),
          meta: { keepAlive: true },
        },
        { path: 'order/orderList', component: () => import('@/views/order/OrderList.vue'), meta: { keepAlive: true } },
        {
          path: 'distributor/distributorList',
          component: () => import('@/views/distributor/DistributorList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorStaffList',
          component: () => import('@/views/distributor/DistributorStaffList.vue'),
          meta: { keepAlive: true },
        },
        { path: 'user/userList', component: () => import('@/views/user/UserList.vue'), meta: { keepAlive: true } },
        {
          path: 'user/withdrawalApplicationList',
          component: () => import('@/views/user/WithdrawalApplicationList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'system/appInfoList',
          component: () => import('@/views/system/AppInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'system/systemConfig',
          component: () => import('@/views/system/SystemConfig.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'web/recommendTypeList',
          component: () => import('@/views/web/RecommendTypeList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'web/recommendRecordList',
          component: () => import('@/views/web/RecommendRecordList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/promotionLinkData',
          component: () => import('@/views/data/PromotionLinkData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/dataDailySum',
          component: () => import('@/views/data/DataDailySum.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/hour/promotionLinkHourData',
          component: () => import('@/views/data/hour/PromotionLinkHourData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/hour/bookHourData',
          component: () => import('@/views/data/hour/BookHourData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/hour/opHourData',
          component: () => import('@/views/data/hour/OpHourData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/promotionLinkDayData',
          component: () => import('@/views/data/PromotionLinkDayData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/userDayDate',
          component: () => import('@/views/data/UserDayDate.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/repurchaseData',
          component: () => import('@/views/data/RepurchaseData.vue'),
          meta: { keepAlive: true },
        },
        { path: 'data/bookData', component: () => import('@/views/data/BookData.vue'), meta: { keepAlive: true } },
        {
          path: 'data/bookDataOcean',
          component: () => import('@/views/data/BookDataOcean.vue'),
          meta: { keepAlive: true },
        },
        { path: 'data/bookDataKs', component: () => import('@/views/data/BookDataKs.vue'), meta: { keepAlive: true } },
        { path: 'data/ksNaData', component: () => import('@/views/data/ksNaData.vue'), meta: { keepAlive: true } },
        {
          path: 'data/bookFullData',
          component: () => import('@/views/data/BookFullData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/promotionV2DayData',
          component: () => import('@/views/data/PromotionV2DayData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/promotionPlayletDayData',
          component: () => import('@/views/data/PromotionPlayletDayData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/orderDistributorMonthCollect',
          component: () => import('@/views/data/orderDistributorCollect/DistributorMonthCollect.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/dataBookDateOcean',
          component: () => import('@/views/data/DataBookDateOcean.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/dataAppDayOut',
          component: () => import('@/views/data/DataAppDayOut.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'data/dataAppDaySummary',
          component: () => import('@/views/data/DataAppDaySummary.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'channel/channelList',
          component: () => import('@/views/channel/ChannelList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'channel/channelBookList',
          component: () => import('@/views/channel/ChannelBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaAdList',
          component: () => import('@/views/promotion/MediaAdList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/promotionLinkProblemList',
          component: () => import('@/views/promotion/PromotionLinkProblemList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaDominantList',
          component: () => import('@/views/promotion/MediaDominantList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaAdvertiserInfoList',
          component: () => import('@/views/promotion/MediaAdvertiserInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaCboGroup',
          component: () => import('@/views/promotion/MediaCboGroup.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaAutoCreateList',
          component: () => import('@/views/promotion/MediaAutoCreateList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaAutoCreateTestBookList',
          component: () => import('@/views/promotion/MediaAutoCreateTestBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'promotion/mediaRejectReasonList',
          component: () => import('@/views/promotion/MediaRejectReasonList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'auto/autoRuleList',
          component: () => import('@/views/auto/AutoRuleList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'auto/autoRuleGroupList',
          component: () => import('@/views/auto/AutoRuleGroupList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'videoCut/videoCutTaskList',
          component: () => import('@/views/videoCut/VideoCutTaskList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'videoCut/videoCutResultList',
          component: () => import('@/views/videoCut/VideoCutResultList.vue'),
          meta: { keepAlive: true },
        },

        {
          path: 'dis/data/promotionLinkDayData',
          component: () => import('@/views/dis/data/PromotionLinkDayData.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/data/bookDataOcean',
          component: () => import('@/views/dis/data/BookDataOcean.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/book/bookList',
          component: () => import('@/views/dis/book/BookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/book/chapterList',
          component: () => import('@/views/dis/book/ChapterList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/user/userList',
          component: () => import('@/views/dis/user/UserList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/promotion/postbackStrategyList',
          component: () => import('@/views/dis/promotion/PostbackStrategyList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/promotion/promotionLinkList',
          component: () => import('@/views/dis/promotion/PromotionLinkList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/order/orderList',
          component: () => import('@/views/dis/order/OrderList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/operate/payTemplateList',
          component: () => import('@/views/dis/operate/PayTemplateList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/distributor/distributorStaffList',
          component: () => import('@/views/dis/distributor/DistributorStaffList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'dis/distributor/distributorCollectMonthList',
          component: () => import('@/views/dis/distributor/DistributorCollectMonthList.vue'),
          meta: { keepAlive: true },
        },

        { path: 'cp/cpList', component: () => import('@/views/cp/CpList.vue'), meta: { keepAlive: true } },
        {
          path: 'cp/cpCollectMonthList',
          component: () => import('@/views/cp/CpCollectMonthList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'cp/cpCollectMonthBookList',
          component: () => import('@/views/cp/CpCollectMonthBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'cp/cpCollectDayBookList',
          component: () => import('@/views/cp/CpCollectDayBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectMonthList',
          component: () => import('@/views/distributor/DistributorCollectMonthList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectMonthBookList',
          component: () => import('@/views/distributor/DistributorCollectMonthBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectDayList',
          component: () => import('@/views/distributor/DistributorCollectDayList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectDayBookList',
          component: () => import('@/views/distributor/DistributorCollectDayBookList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectMonthEmployeeList',
          component: () => import('@/views/distributor/DistributorCollectMonthEmployeeList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectMonthBookEmployeeList',
          component: () => import('@/views/distributor/DistributorCollectMonthBookEmployeeList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'distributor/distributorCollectDayBookEmployeeList',
          component: () => import('@/views/distributor/DistributorCollectDayBookEmployeeList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'settlement/distributionSettlementList',
          component: () => import('@/views/settlement/DistributionSettlementList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'settlement/cpSettlementList',
          component: () => import('@/views/settlement/CpSettlementList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'settlement/distributionSettlementAdminList',
          component: () => import('@/views/settlement/DistributionSettlementAdminList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediamaterial/mediaMaterialExampleList',
          component: () => import('@/views/mediamaterial/MediaMaterialExampleList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediamaterial/MediaAdvertiserInfoList',
          component: () => import('@/views/mediamaterial/MediaAdvertiserInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediamaterial/MediaAdvertiserInfoDetails',
          component: () => import('@/views/mediamaterial/mediamaterial/MediaAdvertiserInfoDetails.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediamaterial/mediaMaterialAudienceInfoList',
          component: () => import('@/views/mediamaterial/MediaMaterialAudienceInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediaautocreate/mediaAutoCreateInfoList',
          component: () => import('@/views/mediaautocreate/MediaAutoCreateInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediagroup/MediaGroupInfoList',
          component: () => import('@/views/mediagroup/MediaGroupInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediagroup/MediaCopyGroupDetails',
          component: () => import('@/views/mediagroup/mediagroup/MediaCopyGroupDetails.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'mediaautocreatetemplate/MediaAutoCreateTemplateList',
          component: () => import('@/views/mediaautocreatetemplate/MediaAutoCreateTemplateList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'playlet/PlayletInfoList',
          component: () => import('@/views/playlet/PlayletInfoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'playlet/PlayletVideoList',
          component: () => import('@/views/playlet/PlayletVideoList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'feedback/WechatComplaintList',
          component: () => import('@/views/feedback/WechatComplaintList.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'feedback/orderInfo',
          component: () => import('@/views/feedback/OrderInfo.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'order/wxBillDownload',
          component: () => import('@/views/order/WXBillDownload.vue'),
          meta: { keepAlive: true },
        },
        {
          path: 'order/wxBalance',
          component: () => import('@/views/order/WXBalance.vue'),
          meta: { keepAlive: true },
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/loginPage.vue'),
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
